import styled from 'styled-components';

import { Root as ButtonRoot } from '../../../../components/Button/Button.styles';
import { Text } from '../../../../components/Text/Text';
import { COLORS, MOBILE, SPACE } from '../../../../theme/tokens';

/** The card's body: what is happening (mark, headline, status) beside its actions, then progress and detail. */
export const Root = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[16]};
`;

export const Head = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${SPACE[16]};

  ${MOBILE} {
    flex-direction: column;
    gap: ${SPACE[12]};
  }
`;

export const Lead = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: flex-start;
  gap: ${SPACE[12]};
`;

/** The leading mark, toned by the job's state. */
export const Mark = styled.span<{ $tone: 'neutral' | 'danger' }>`
  flex: none;
  display: inline-flex;
  margin-top: ${SPACE[2]};
  color: ${({ $tone }) => ($tone === 'danger' ? COLORS.danger : COLORS.accent)};
`;

export const Copy = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: ${SPACE[4]};
`;

export const Eyebrow = styled(Text)`
  font-size: 12px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${COLORS.textFaint};
`;

export const Title = styled(Text)`
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  line-height: 1.35;
  color: ${COLORS.text};
`;

export const Status = styled(Text)`
  margin: 0;
  font-size: 14px;
  line-height: 1.45;
  color: ${COLORS.textMuted};
`;

export const Note = styled(Text)`
  margin: 0;
  font-size: 13px;
  line-height: 1.45;
  color: ${COLORS.textFaint};
`;

export const Actions = styled.div`
  flex: none;
  display: flex;
  flex-wrap: wrap;
  gap: ${SPACE[8]};

  ${MOBILE} {
    width: 100%;
  }
`;

/** "Preview on your site": the outline button's look, as a link that opens the site in a new tab. */
export const PreviewLink = styled(ButtonRoot)`
  text-decoration: none;
`;

export const Progress = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[8]};
`;

/** casino-creation's own reason (a switch or a revert it refused), as it gave it. */
export const Reason = styled(Text)`
  display: block;
  margin: 0;
  padding: ${SPACE[8]} ${SPACE[12]};
  border-left: 2px solid ${COLORS.danger};
  font-size: 13px;
  line-height: 1.45;
  color: ${COLORS.textMuted};
  overflow-wrap: anywhere;
`;

export const Parts = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[8]};
`;

export const PartsLabel = styled(Text)`
  font-size: 13px;
  font-weight: 600;
  color: ${COLORS.text};
`;

export const PartList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: ${SPACE[8]};
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const Part = styled.li`
  padding: ${SPACE[4]} ${SPACE[8]};
  border: 1px solid ${COLORS.hairline};
  border-radius: 99px;
  font-size: 12.5px;
  color: ${COLORS.textMuted};
`;
